var WorkspaceMigrationStatusCodes = /* @__PURE__ */ ((WorkspaceMigrationStatusCodes2) => {
  WorkspaceMigrationStatusCodes2[WorkspaceMigrationStatusCodes2["MovedPermanently"] = 301] = "MovedPermanently";
  WorkspaceMigrationStatusCodes2[WorkspaceMigrationStatusCodes2["MethodNotAllowed"] = 405] = "MethodNotAllowed";
  WorkspaceMigrationStatusCodes2[WorkspaceMigrationStatusCodes2["NotAcceptable"] = 406] = "NotAcceptable";
  return WorkspaceMigrationStatusCodes2;
})(WorkspaceMigrationStatusCodes || {});
export {
  WorkspaceMigrationStatusCodes
};
//# sourceMappingURL=WorkspaceMigrationModels.js.map
